import React, { Component } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { Space, Radio,message, Spin } from "antd";
import Bridge from "../../utils/Bridge";
import { ECAS_ALSFRS_R_FIELDS, ECAS_ALSFRS_R_CUTTING_FOOD_A_OPTIONS, ECAS_ALSFRS_R_CUTTING_FOOD_B_OPTIONS } from "../../utils/consts";
import moment from "moment";

export default class AddAlsfrsr extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      field_data:ECAS_ALSFRS_R_FIELDS,
      speech:"",
      salivation:"",
      swallowing:"",
      handwriting:"",
      participant_uses_gastronomy:"",
      cutting_food_a:"",
      cutting_food_b:"",
      dressing_and_hygine:"",
      turning_bed:"",
      walking:"",
      climbing_stairs:"",
      dyspnea:"",
      orthopnea:"",
      respiratory_insufficiency:"",
      questions:{
        cutting_food_a:[],
        cutting_food_b:[],
      },
    };
  }
  save_details=()=>{
    if (!this.state.speech) {
      message.warning("Please select Speech value");
      return;
    }
    if (!this.state.salivation) {
      message.warning("Please select Salivation value");
      return;
    }
    if (!this.state.swallowing) {
      message.warning("Please select Swallowing value");
      return;
    }
    if (!this.state.handwriting) {
      message.warning("Please select Handwriting value");
      return;
    }
    if (!this.state.participant_uses_gastronomy) {
      message.warning("Please select 'Participant uses gastronomy' value");
      return;
    }
    if (this.state.cutting_food_a=="" && this.state.cutting_food_b=="") {
      message.warning(
        "Please select 'Cutting food and handling utensils' value"
      );
      return;
    }
    if (!this.state.dressing_and_hygine) {
      message.warning("Please select Dressing and hygiene value");
      return;
    }
    if (!this.state.turning_bed) {
      message.warning("Please select Turning bed value");
      return;
    }
    if (!this.state.walking) {
      message.warning("Please select Walking value");
      return;
    }
    if (!this.state.climbing_stairs) {
      message.warning("Please select Climbing stairs value");
      return;
    }
    if (!this.state.dyspnea) {
      message.warning("Please select Dyspnea value");
      return;
    }
    if (!this.state.orthopnea) {
      message.warning("Please select Orthopnea value");
      return;
    }
    if (!this.state.respiratory_insufficiency) {
      message.warning("Please select Respiratory insufficiency value");
      return;
    }
    let ALS_total = 0;
    ALS_total += Number(this.state.speech == "" ? 0 : this.state.speech);
    ALS_total += Number(this.state.salivation == "" ? 0 : this.state.salivation);
    ALS_total += Number(this.state.swallowing == "" ? 0 : this.state.swallowing);
    ALS_total += Number(this.state.handwriting == "" ? 0 : this.state.handwriting);
    ALS_total += Number(this.state.cutting_food_a == "" ? 0 : this.state.cutting_food_a);
    ALS_total += Number(this.state.cutting_food_b == "" ? 0 : this.state.cutting_food_b);
    ALS_total += Number(this.state.dressing_and_hygine == "" ? 0 : this.state.dressing_and_hygine);
    ALS_total += Number(this.state.turning_bed == "" ? 0 : this.state.turning_bed);
    ALS_total += Number(this.state.walking == "" ? 0 : this.state.walking);
    ALS_total += Number(this.state.climbing_stairs == "" ? 0 : this.state.climbing_stairs);
    ALS_total += Number(this.state.dyspnea == "" ? 0 : this.state.dyspnea);
    ALS_total += Number(this.state.orthopnea == "" ? 0 : this.state.orthopnea);
    ALS_total += Number(this.state.respiratory_insufficiency == "" ? 0 : this.state.respiratory_insufficiency);

    const params = {
      speech: this.state.speech,
      salivation: this.state.salivation,
      swallowing: this.state.swallowing,
      handwriting: this.state.handwriting,
      participant_uses_gastronomy: this.state.participant_uses_gastronomy,
      cutting_food_a: this.state.cutting_food_a,
      cutting_food_b: this.state.cutting_food_b,
      dressing_and_hygine: this.state.dressing_and_hygine,
      turning_bed: this.state.turning_bed,
      walking: this.state.walking,
      climbing_stairs: this.state.climbing_stairs,
      dyspnea: this.state.dyspnea,
      orthopnea: this.state.orthopnea,
      respiratory_insufficiency: this.state.respiratory_insufficiency,
      eals_id: localStorage.getItem("ap_eals_id"),
      ALS_total: ALS_total,
      date: moment().format("YYYY-MM-DD HH:mm:ss A"),
    };
    this.setState({ loading: true });
    Bridge.participants.ecas_study.save_alsfrsr_score(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          message.success(response.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              setTimeout(() => {
                window.location.assign("/dashboard");
              }, 3000);
            }
          );
        } else {
          message.error(response.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  }
  render() {
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-11 m-auto">
                <div className="demographic-single-section">
                  <a href="/dashboard" className="back-arrow">
                    <box-icon
                      name="chevron-left"
                      color="#fff"
                      style={{ position: "relative", top: 1 }}
                    ></box-icon>
                    Dashboard
                  </a>
                  <div>
                    <div className="header">
                      <h3 className="text-uppercase">ALSFRS-R</h3>
                      <div className="white-block"></div>
                    </div>
                    <div className="form-fields">
                      <Spin spinning={this.state.loading}>
                        <div>
                          
                          {this.state.field_data.map((item,index)=>{
                            if(item.field=='SPEECH_FTORRES'||item.field=='SALIVA_FTORRES'||item.field=='SWALLOW_FTORRES'||item.field=='HNDWRIT_FTORRES'){
                              return (
                                <div className="form-group" key={index}>
                                  <label className="input-heading">
                                    {item.field_label}{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <br />
                                  <Radio.Group
                                    onChange={(e) =>
                                      this.setState({
                                        [item.state_name]: e.target.value,
                                      })
                                    }
                                    value={this.state[item.state_name]}
                                    direction={item.status_name=='participant_uses_gastronomy' ? 'horizontal' : 'vertical'}
                                  >
                                    <Space direction="vertical">
                                      {item.options.map((single,i)=>{
                                        return (<Radio value={single.value}>{single.label}</Radio>)
                                      })}
                                    </Space>
                                  </Radio.Group>
                                </div>
                              )
                            }
                          })}

                          <div className="form-group">
                            <label className="input-heading">
                            5. Participant uses a gastrostomy for greater than 50% of nutrition:{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  participant_uses_gastronomy: e.target.value,
                                  cutting_food_a:"",
                                  cutting_food_b:""
                                })
                              }
                              value={this.state.participant_uses_gastronomy}
                              direction="horizontal"
                            >
                              <Space direction="horizontal">
                                <Radio value={1}>Yes</Radio>
                                <Radio value={2}>No</Radio>
                              </Space>
                            </Radio.Group>
                          </div>                          
                          {this.state.participant_uses_gastronomy && (
                            <>
                              {this.state.participant_uses_gastronomy=='1'? (
                                <div className="form-group">
                                  <label className="input-heading">
                                    5b. Cutting Food and Handling Utensils (alternate scale for participants with gastrostomy):{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <br />
                                  <Radio.Group
                                    onChange={(e) =>
                                      this.setState({
                                        cutting_food_b: e.target.value,
                                      })
                                    }
                                    value={this.state.cutting_food_b}
                                    direction="vertical"
                                  >
                                    <Space direction="vertical">
                                      {ECAS_ALSFRS_R_CUTTING_FOOD_B_OPTIONS.map((single,i)=>{
                                        return (<Radio value={single.value}>{single.label}</Radio>)
                                      })}
                                    </Space>
                                  </Radio.Group>
                                </div>
                              ):(
                                <div className="form-group">
                                  <label className="input-heading">
                                  5a. Cutting Food and Handling Utensils (participants without gastrostomy):{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <br />
                                  <Radio.Group
                                    onChange={(e) =>
                                      this.setState({
                                        cutting_food_a: e.target.value,
                                      })
                                    }
                                    value={this.state.cutting_food_a}
                                    direction="vertical"
                                  >
                                    <Space direction="vertical">
                                      {ECAS_ALSFRS_R_CUTTING_FOOD_A_OPTIONS.map((single,i)=>{
                                        return (<Radio value={single.value}>{single.label}</Radio>)
                                      })}
                                    </Space>
                                  </Radio.Group>
                                </div>
                              )}
                            </>
                          )}

                          {this.state.field_data.map((item,index)=>{
                            if(['HYGIENE_FTORRES','BEDCLOTH_FTORRES','WALKING_FTORRES','STAIRS_FTORRES','DYSPNEA_FTORRES','ORTHO_FTORRES','RESPINS_FTORRES'].includes(item.field)){
                              return (
                                <div className="form-group" key={index}>
                                  <label className="input-heading">
                                    {item.field_label}{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <br />
                                  <Radio.Group
                                    onChange={(e) =>
                                      this.setState({
                                        [item.state_name]: e.target.value,
                                      })
                                    }
                                    value={this.state[item.state_name]}
                                    direction="vertical"
                                  >
                                    <Space direction="vertical">
                                      {item.options.map((single,i)=>{
                                        return (<Radio value={single.value}>{single.label}</Radio>)
                                      })}
                                    </Space>
                                  </Radio.Group>
                                </div>
                              )
                            }
                          })}
                          <button
                            className="submit-button"
                            style={{ padding: "9px 15px 10px 20px" }}
                            onClick={() => this.save_details()}
                          >
                            <box-icon
                              name="save"
                              type="solid"
                              color="#fff"
                              size={'17px'}
                              style={{ position: 'relative', top: -1, left: -11 }}
                            ></box-icon>
                            Save{" "}
                          </button>
                        </div>
                      </Spin>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
